import {Injectable} from '@angular/core'

@Injectable()

export class FiltrosServices {


  tabla = 'rest_filtros_service';
  data;

  constructor() {

    this.data = JSON.parse(localStorage.getItem(this.tabla)) || {tareas: null, pedidos: null, albaranes: null};

  }


  get(key) {

    return this.data[key];

  }


  set(key, value) {

    this.data[key] = value;
    localStorage.setItem(this.tabla, JSON.stringify(this.data));

    return this.data[key];

  }


  delete() {

    localStorage.removeItem(this.tabla);
  }


}



// WEBPACK FOOTER //
// ./src/services/FiltrosServices.ts